import { LOCATION_CHANGE } from 'connected-react-router';
import { Action } from 'redux-actions';
import { ActionsObservable, combineEpics, ofType, StateObservable } from 'redux-observable';
import { Observable, of, merge } from 'rxjs';
import { StoreState } from '../store/StoreState';
import { MenuActionType, menuActions } from './MenuActions';
import { contentfulClient } from '../contentful/contentfulClient';
import { catchError, filter, map, mapTo, switchMap, withLatestFrom } from 'rxjs/operators';

function changeLocationTriggerForDataLoading(
    actions$: ActionsObservable<Action<any>>,
    state$: StateObservable<StoreState>): Observable<Action<any>> {
    return actions$.pipe(
        ofType(LOCATION_CHANGE),
        withLatestFrom(state$),
        filter(([, state]) => !(state as StoreState).menu.loaded),
        mapTo(menuActions.menuDataLoadStartAction())
    );
}

function changeLocationTriggerMenuExpanded(actions$: ActionsObservable<Action<any>>): Observable<Action<any>> {
    return actions$.pipe(
        ofType(LOCATION_CHANGE),
        mapTo(menuActions.menuBarToggled(false))
    );
}

function loadDataEpic(actions$: ActionsObservable<Action<any>>): Observable<Action<any>> {
    return actions$.pipe(
        ofType(MenuActionType.DATA_LOAD_START),
        switchMap(() => merge(
            of(menuActions.menuDataLoadingAction()),
            contentfulClient.getMenuItems().pipe(
                map(payload => menuActions.menuDataLoadSuccessAction(payload)),
                catchError(err => of(menuActions.menuDataLoadFailedAction(err)))
            ))
        )
    );
}

export const menuEpic = combineEpics(
    changeLocationTriggerForDataLoading,
    changeLocationTriggerMenuExpanded,
    loadDataEpic
);



// WEBPACK FOOTER //
// ./src/menu/MenuEpic.ts